import React, { useRef } from 'react';
import {
  Dialog,
  DialogBackdrop,
  DialogDescription,
  DialogPanel,
  DialogTitle,
} from '@headlessui/react';

interface SeriesScopeDialogProps {
  action: 'save' | 'delete';
  onChoose: (scope: 'single' | 'series') => void;
  onCancel: () => void;
  busy?: boolean;
}

const SeriesScopeDialog: React.FC<SeriesScopeDialogProps> = ({ action, onChoose, onCancel, busy }) => {
  const verb = action === 'delete' ? 'Delete' : 'Save';
  const singleRef = useRef<HTMLButtonElement>(null);
  return (
    <Dialog open onClose={() => { if (!busy) onCancel(); }} initialFocus={singleRef} className="relative z-[80]">
      <DialogBackdrop className="fixed inset-0 bg-black/60" />
      <div className="fixed inset-0 overflow-y-auto p-4">
        <div className="flex min-h-full items-center justify-center">
          <DialogPanel className="w-full max-w-sm rounded-lg bg-white p-5 shadow-xl dark:bg-gray-900 dark:text-gray-100">
            <DialogTitle className="text-base font-semibold">{verb} repeating event</DialogTitle>
            <DialogDescription className="mt-2 text-sm text-gray-600 dark:text-gray-300">
              This event is part of a series. Choose whether to {verb.toLowerCase()} this occurrence or the complete series.
            </DialogDescription>
            <div className="mt-5 flex flex-col gap-2">
              <button ref={singleRef} type="button" onClick={() => onChoose('single')} disabled={busy} className="min-h-11 w-full rounded-md border border-gray-300 px-4 text-sm font-medium text-gray-700 hover:bg-gray-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-club-blue-500 disabled:opacity-50 dark:border-gray-600 dark:text-gray-200 dark:hover:bg-gray-800">This event only</button>
              <button type="button" onClick={() => onChoose('series')} disabled={busy} className={`min-h-11 w-full rounded-md px-4 text-sm font-medium text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:opacity-50 ${action === 'delete' ? 'bg-red-600 hover:bg-red-700' : 'bg-blue-600 hover:bg-blue-700'}`}>All events in series</button>
              <button type="button" onClick={onCancel} disabled={busy} className="min-h-11 w-full rounded-md px-4 text-sm text-gray-600 hover:bg-gray-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-club-blue-500 dark:text-gray-300 dark:hover:bg-gray-800">Cancel</button>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
};

export default SeriesScopeDialog;
